// Create and open the modal

function floowOpenModal(content) {
  const modal = document.querySelector(".floow-modal");

  if (!modal) {
    // If theres no modal container, create one and put it at the beginning of the body
    const modalText = `
      <div class="floow-modal">
        <div class="floow-modal-background" onclick="floowCloseModal();"></div>
        <div class="floow-modal-content-container">
          <svg 
            class="floow-modal-close"
            onclick="floowCloseModal()"
            role="presentation" stroke-width="2" focusable="false" width="24" height="24" viewBox="0 0 24 24">
              <path d="M17.658 6.343 6.344 17.657M17.658 17.657 6.344 6.343"></path>
          </svg>
          <div class="floow-modal-content"></div>
        </div>
      </div>  
      `;
    const modalHTML = new DOMParser().parseFromString(modalText, "text/html");
    const modalElement = modalHTML.body.querySelector(".floow-modal");
    document.body.prepend(modalElement);
  }

  // Put the content in the modal
  const modalContent = document.querySelector(".floow-modal-content");
  modalContent.innerHTML = content.innerHTML;

  // Open the modal
  document.querySelector(".floow-modal").setAttribute("open", "");
}

// Close the modal

function floowCloseModal() {
  document.querySelector(".floow-modal").removeAttribute("open");
  document.body.classList.remove('hide-overflow');
}

// Money formatting
 function floowFormatMoney(cents) {
  const price = (cents / 100).toFixed(2);
  if (price <= 0) return '';
  return price.replace(".", ",") + " €";
}


// Initialize slider

function floowInitializeSlider(settings, id) {
  const sliderId = id;
  const slider = document.querySelector(`.slider-${sliderId}`);
  const leftArrow = document.querySelector(`.left-arrow-${sliderId}`);
  const rightArrow = document.querySelector(`.right-arrow-${sliderId}`);
  const slides = Array.from(slider.children);
  let activeSlide = 0;

  slides.forEach((slide, i) => {
    slide.setAttribute("data-index", `${i}-${id}`) 
  })

  floowCalculateSlideWidth(slider, slides, settings, activeSlide, id);

  const resizeObserver = new ResizeObserver(entries => {
    for (let entry of entries) {
      floowCalculateSlideWidth(slider, slides, settings, activeSlide, id)
    }
  });

  resizeObserver.observe(slider);




  // Left arrow
  leftArrow.addEventListener("click", () => {
     if (activeSlide > 0) {
       activeSlide -= 1;
       rightArrow.classList.remove("floow-arrow-inactive");

       if (activeSlide == 0) leftArrow.classList.add("floow-arrow-inactive");
    
       document.querySelector(`.block-${id}[data-index="${activeSlide}-${id}"]`).scrollIntoView({ inline: "start", behavior: 'smooth', block: 'nearest' });
    }
  });

  // Right arrow
  rightArrow.addEventListener("click", () => {
    if (window.innerWidth > settings.mobile.width) {
       if (activeSlide < slides.length - settings.slidesPerView) activeSlide += 1;
       if (activeSlide == slides.length - settings.slidesPerView) rightArrow.classList.add("floow-arrow-inactive");
    } else {
      if (activeSlide < slides.length - settings.mobile.slidesPerView) activeSlide += 1;
      if (activeSlide == slides.length - settings.mobile.slidesPerView) rightArrow.classList.add("floow-arrow-inactive");
    }

    console.log(slides.length - settings.slidesPerView)
    console.log(activeSlide)
    leftArrow.classList.remove("floow-arrow-inactive");
    document.querySelector(`.block-${id}[data-index="${activeSlide}-${id}"]`).scrollIntoView({ inline: "start", behavior: 'smooth', block: 'nearest' });
  });
}

// Calculate slide width depending on viewport
function floowCalculateSlideWidth(slider, slides, settings, activeSlide, id) {
  let sliderWidth = slider.getBoundingClientRect().width;
  console.log(slider.getBoundingClientRect().width);
  let slideWidth;

  if (window.innerWidth > settings.mobile.width) {
    slideWidth = (sliderWidth - settings.gap * (settings.slidesPerView - 1)) / settings.slidesPerView;
  } else {
    slideWidth = (sliderWidth - settings.mobile.gap * (settings.mobile.slidesPerView - 1)) / settings.mobile.slidesPerView;
  }

  slides.forEach((slide) => {
    slide.style.width = `${slideWidth}px`;
  });
  document.querySelector(`.block-${id}[data-index="${activeSlide}-${id}"]`).scrollIntoView({ inline: "start", behavior: 'smooth', block: 'nearest' });
}


function floowChangeVariant(productId, event, buttonText, soldOutText) {
  const productData = JSON.parse(
    document.getElementById(`product-data-${productId}`).textContent
  );

  const wrapper = document.querySelector(
    `.floow-variant-picker-wrapper[product-id="${productId}"]`
  );
  const currency = wrapper.dataset.currency;

  // Collect selected options
  const selectedOptions = [];
  document.querySelectorAll(".floow-variant-picker-select").forEach(select => {
    selectedOptions.push(select.value);
  });

  // Find matching variant
  const matchedVariant = productData.variants.find(variant =>
    variant.options.every((opt, index) => opt === selectedOptions[index])
  );

  if (!matchedVariant) return;

  // Update image
  if (matchedVariant.featured_image) {
    document.querySelector(".floow-variant-picker-image").src =
      matchedVariant.featured_image.src;
  }

  // Update price
  document.querySelector(".floow-variant-picker-price").textContent =
    (matchedVariant.price / 100).toFixed(2) + " " + currency;

    const unitPrice = document.querySelector("floow-variant-picker-unit-price");
    if (matchedVariant.unit_price && matchedVariant.unit_price_measurement) {
      const refValue = matchedVariant.unit_price_measurement.reference_value;
      const refUnit = matchedVariant.unit_price_measurement.reference_unit;

      unitPriceParagraph.innerHTML =
        formatMoneyEur(matchedVariant.unit_price) + ` /${refValue}${refUnit}`;
  }

  // Update compare at price
  const compareEl = document.querySelector(".floow-variant-picker-compare-at-price");
  if (matchedVariant.compare_at_price > matchedVariant.price) {
    compareEl.textContent =
      (matchedVariant.compare_at_price / 100).toFixed(2) + " " + currency;
  } else {
    compareEl.textContent = "";
  }

  // Update ATC button
  /*
  const atcButton = document.querySelector(".floow-variant-picker-atc");
  atcButton.onclick = () => {
    floowAddToCart(matchedVariant.id, 1, event.target);
    floowCloseModal();
    floowOpenCart();
  }; */

  if (matchedVariant.available) {
    atcButton.classList.remove("floow-variant-picker-disabled");
    atcButton.textContent = buttonText;
  } else {
    atcButton.classList.add("floow-variant-picker-disabled");
    atcButton.textContent = soldOutText;
  }
}


function removeClasses() {
  document.querySelector(".subtotal")?.classList.remove("heading-font", "h4")
}

document.addEventListener('on:cart:after-merge', (event) => {
    removeClasses();
  });

ablyftTools.domLoaded(() => {
   removeClasses();
});
